<template>
    <div class="form-elements">
        <div class="row">
            <fieldset class="col-md-3">
                <legend>Autoescola</legend>
                <model-select :options="selectCFC" v-model="inputsFiltro.cfc" placeholder="Selecione uma auto escola">
                </model-select>
            </fieldset>
            <fieldset class="col-md-3">
                <legend>Dispositivo</legend>
                <model-select :options="[{ text: 'Link', value: 'Link' }, { text: 'Aplicativo', value: 'Aplicativo' }]"
                    v-model="inputsFiltro.dispositivo" placeholder="Selecione um dispositivo">
                </model-select>
            </fieldset>
            <fieldset class="col-md-2" id="nome">
                <legend>
                    <span>Agrupamento</span>
                </legend>
                <div class="form-group">
                    <input type="number" class="form-control pt-0 pl-2 border rounded" id="agrupamento" v-model="inputsFiltro.agrupamento" :disabled="loadTable" min="0" @input="checkNegativeValue">
                </div>
            </fieldset>
            <fieldset class="col-md-2" id="nome">
                <legend>
                    <span>Nome</span>
                </legend>
                <div class="form-group">
                    <input type="text" class="form-control pt-0 pl-2 border rounded" id="nome"
                        v-model="inputsFiltro.nome" :disabled="loadTable">
                </div>
            </fieldset>
        </div>
        <div class="row">
            <fieldset class="col-md-4" id="periodoConsultado">
                <legend>Período a Ser Consultado</legend>
                <div class="form-group">
                    <div class="col-md-6 p-0 pr-2">
                        <input type="date" class="form-control border rounded pl-2 pr-2"
                            v-model="inputsFiltro.dataInicio">
                    </div>
                    <div class="col-md-6 p-0 pl-2">
                        <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputsFiltro.dataFim">
                    </div>
                </div>
            </fieldset>
            <div class="col-md-3 text-right">
                <legend class="espacamento-oculto">.</legend>
                <button class="btn btn-danger col-12 btn-micro" @click="clearInputs()"
                    title="Limpar os dados da página">
                    <i id="clearButton" class="fa fa-file-excel-o pr-3 icon-branco"></i>
                    <span class="font-button-modified">Limpar</span>
                </button>
            </div>
            <div class="col-md-3 text-right">
                <legend class="espacamento-oculto">.</legend>
                <button class="btn btn-info col-12 btn-micro" @click="loadData()" :disabled="loadTable">
                    <template v-if="loadTable">
                        <div class="d-flex justify-content-center">
                            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="20">
                            </component>
                        </div>
                    </template>
                    <template v-else>
                        <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                        <span class="font-button-modified">Consultar</span>
                    </template>
                </button>
            </div>
        </div>

        <div class="row">
            <fieldset class="col-md-1" id="nome">
                <legend>
                    <span>Registros</span>
                </legend>
                <div class="form-group">
                    <input type="text" class="form-control pt-0 pl-2 border rounded" :value="table.total" readonly>
                </div>
            </fieldset>
            <div class="col-md-8">
                <legend class="espacamento-oculto">.</legend>
                <div>
                    <button class="btn btn-warning btn-micro" @click="loadCsv()" :disabled="download.load" title="Baixar CSV de alunos monitorados">
                        <component v-if="download.load" :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="20"></component>
                        Gerar CSV do Monitoramento
                    </button>
                    <div class="texto-obs">Somente filtro de período.</div>
                </div>
            </div>
        </div>

        <div class="row pt-3 d-flex align-items-center flex-column" id="tabela">
            <!--Botões da paginação-->
            <div class="row">
                <div class="col mx-auto">
                    <pagination :source="pagination" @navigate="navigate">
                    </pagination>
                </div>
            </div>
            <!--Botões da paginação-->
            <div v-if="loadTable" class="d-flex justify-content-center my-3">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                </component>
            </div>
            <table v-else class="table table-striped table-bordered table-responsive-sm text-center">
                <thead>
                    <tr>
                        <th>Agrupamento</th>
                        <th>CFC</th>
                        <th>Início</th>
                        <th>Fim</th>
                        <th>Nome</th>
                        <th>Nº de Fotos</th>
                        <th>Dispositivo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="aulas.length === 0">
                        <td colspan="10">Nenhum Registro Encontrado</td>
                    </tr>
                    <tr v-for="(aula, index) in aulas" :key="index" v-else>
                        <td>{{ aula.id_agrupamento }}</td>
                        <td>{{ aula.schema }}</td>
                        <td>{{ aula.inicio }}</td>
                        <td>{{ aula.fim }}</td>
                        <td>{{ aula.nome }}</td>
                        <td>{{ aula.quantidade_fotos }}</td>
                        <td>{{ aula.dispositivo }}</td>
                    </tr>
                </tbody>
            </table>
            <!--Botões da paginação-->
            <div class="row mt-2">
                <div class="col mx-auto">
                    <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center">
                    </pagination>
                </div>
            </div>
            <!--Botões da paginação-->
        </div>
    </div>
</template>

<script>
import InputIconGroup from '../../../../vuestic-theme/vuestic-components/vuestic-input/InputIconGroup.vue'
import FotosTeoricasController from './FotosTeoricasController.js'
import * as spinners from 'epic-spinners'
import urlApi from '@/router/urlApiV2'
import { ModelSelect } from 'vue-search-select'
import pagination from '../../../pagination/pagination.vue'

export default {
  name: 'FotosTeoricas',
  components: {
    InputIconGroup,
    ...spinners,
    ModelSelect,
    pagination
  },
  props: {
    selectCFC: Array,
  },
  data () {
    return {
      loadTable: false,
      inputsFiltro: {
        agrupamento: '',
        cfc: '',
        nome: '',
        dispositivo: '',
        dataInicio: '',
        dataFim: '',
      },
      aulas: [],
      countResult: 0,
      pagination: '',
      table: {
        current_page: '',
        data: '',
        first_page_url: '',
        from: '',
        last_page: '',
        last_page_url: '',
        next_page_url: '',
        path: '',
        per_page: '',
        prev_page_url: '',
        to: '',
        total: '',
        pages: [],
        load: false,
        tp: '',
      },
      download: {
        load: false
      },
    }
  },
  methods: {
    checkNegativeValue() {
      if (this.inputsFiltro.agrupamento < 0) {
        this.inputsFiltro.agrupamento = '';
      }
    },
    loadData () {
      if (this.inputsFiltro.dataInicio != '' && this.inputsFiltro.dataFim == '' || this.inputsFiltro.dataInicio == '' && this.inputsFiltro.dataFim != '') {
        FotosTeoricasController.launchToast('fa-warning', 'Preencha o périodo corretamente.')
      } else {
        this.searchBy()
      }
    },
    searchBy () {
      var data = {
        agrupamento: parseInt(this.inputsFiltro.agrupamento),
        cfc: this.inputsFiltro.cfc,
        nome: this.inputsFiltro.nome,
        dispositivo: this.inputsFiltro.dispositivo,
        dataInicio: this.inputsFiltro.dataInicio,
        dataFim: this.inputsFiltro.dataFim,
      }

      this.queryResult(data)
    },
    queryResult (data) {
      this.consult = `${urlApi}/aulas/teoricas/monitoramento/fotos/consultar/filtros?agrupamento=${data.agrupamento}&cfc=${data.cfc}&nome=${data.nome}&dispositivo=${data.dispositivo}&periodo[]=${data.dataInicio}&periodo[]=${data.dataFim}`

      this.loadTable = true

      FotosTeoricasController.queryResult(data, (response) => {
        response.then(
          this.loadTable = false,
          this.aulas = response.data,
          this.callbackDataPaginate(response),
          this.countResult = response.data.length,
          this.aulasTotal = response.dados.total,
        ).catch(
          this.aulas = '',
          this.countResult = 0,
          this.loadTable = false,
        )
      })
    },
    callbackDataPaginate (response) {
      let res = response
      this.table.current_page = res.current_page
      this.aulas = res.data
      this.table.first_page_url = res.first_page_url
      this.table.from = res.from
      this.table.last_page = res.last_page
      this.table.last_page_url = res.last_page_url
      this.table.next_page_url = res.next_page_url
      this.table.path = res.path
      this.table.per_page = res.per_page
      this.table.prev_page_url = res.prev_page_url
      this.table.to = res.to
      this.table.total = res.total
      this.table.pages = []

      for (let i = 1; i <= res.last_page; i++) {
        this.table.pages.push(i)
      }

      this.table.load = false
      this.pagination = res
      this.tp = res.data.length
    },

    async navigate (page) {
      this.table.load = true
      this.loadTable = true

      await this.$http.get(`${this.consult}&page=${page}`).then(function (response) {
        this.callbackDataPaginate(response.body.dados)

        this.loadTable = false
      })
      this.table.load = false
    },
    clearInputs () {
      this.loadTable = false
      this.aulas = []
      this.inputsFiltro.agrupamento = ''
      this.inputsFiltro.cfc = ''
      this.inputsFiltro.dispositivo = ''
      this.inputsFiltro.dataInicio = ''
      this.inputsFiltro.dataFim = ''
      this.countResult = 0
      this.table.total = ''
      this.table.pages = []
      this.pagination = ''
    },
    loadCsv () {
      if (this.inputsFiltro.dataInicio != '' && this.inputsFiltro.dataFim == '' || this.inputsFiltro.dataInicio == '' && this.inputsFiltro.dataFim != '') {
        FotosTeoricasController.launchToast('fa-warning', 'Preencha o périodo corretamente.')
      } else {
        this.baixaAlunosMonitorados()
      }
    },
    baixaAlunosMonitorados () {
      const data = {
        dataInicio: this.inputsFiltro.dataInicio,
        dataFim: this.inputsFiltro.dataFim,
      }

      this.download.load = true

      FotosTeoricasController.getAlunosMonitorados(data, (response) => {
        if (response.sucesso === false) {
          this.download.load = false
        } else {
          var csv = 'data:text/csv;charset=utf-8,' + response.dados
          var dlnk = document.getElementById('downloadCSV')
          dlnk.download = 'alunos_monitorados.csv'
          dlnk.href = csv
          dlnk.click()
          this.download.load = false
        }
      })
    },
  },
}
</script>
<style>
.espacamento-oculto {
    color: transparent;
    user-select: none;
}

.texto-obs {
    margin: 6px 0 0 30px;
    font-size: 14px;
}
</style>
